<template>
    <el-col :xs="24" :md="24" :cols="24">
        <div id="colderecha" style="display: flex;  justify-content: center;  flex-direction: column; align-items: center;">
            <div v-if="!loading" style="width: 100%;">
                <div style="padding: 5px; display:flex; justify-content: space-between;">
                    <el-button type="warning" @click="$router.push('/dashboard')">Volver</el-button>
                </div>
            </div>
            <table style="width: 100%" v-loading="loading" class="display">
                <thead>
                    <tr>
                        <th>Documento</th>
                        <th>Estado</th>
                        <th>Fecha envío</th>
                        <th>Destinatario/s</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><el-input v-model="filtros.nombre" placeholder="Escribe un nombre para buscar"></el-input></td>
                        <td><el-input v-model="filtros.estado" placeholder="Escribe un estado para buscar"></el-input></td>
                        <td><el-input v-model="filtros.fechaEnvio" placeholder="Escribe una fecha para buscar"></el-input>
                        </td>
                        <td><el-input v-model="filtros.destinatarios"
                                placeholder="Escribe un destinatario para buscar"></el-input></td>
                        <td></td>
                    </tr>
                    <tr v-for="documento in objetoCortado" :key="documento.idDocumento">
                        <td>{{ documento.nombreDocumento }}</td>
                        <td>{{ documento.estadoFirmado }}</td>
                        <td>{{ documento.fecha }}</td>
                        <td>{{ documento.destinatario }}</td>
                        <td v-loading="documento.loading">
                            <el-tooltip content="Obtener información" placement="bottom" effect="dark">
                                <el-button size="large" @click="infoDocumento(documento)" type="warning"><el-icon
                                        size="large">
                                        <InfoFilled />
                                    </el-icon></el-button>
                            </el-tooltip>
                            <el-tooltip v-if="documento.estadoFirmado == 'Firmado'" content="Descargar documento"
                                placement="bottom" effect="dark">
                                <el-button size="large" @click="descargarDocumento(documento, 'documento')"
                                    type="warning"><el-icon size="large">
                                        <Download />
                                    </el-icon></el-button>
                            </el-tooltip>
                            <el-tooltip v-if="documento.estadoFirmado == 'Firmado'" content="Descargar certificado"
                                placement="bottom" effect="dark">
                                <el-button size="large" @click="descargarDocumento(documento, 'certificado')"
                                    type="warning"><el-icon size="large">
                                        <Document />
                                    </el-icon></el-button>
                            </el-tooltip>
                        </td>
                    </tr>
                </tbody>
            </table>
            <el-pagination v-if="!loading" background class="mt-3" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" v-model:currentPage="paginaActual" v-model:pageSize="objetosPorPagina"
                :page-sizes="[10, 20, 25, 50, 100, 150, 200]" layout="prev, pager, next, jumper, sizes, total"
                :total="panelFiltrado.length">
            </el-pagination>
        </div>
    </el-col>
</template>

<script>
import { mapState } from 'vuex'
import { ElMessageBox } from 'element-plus'
import download from 'downloadjs';

export default {
    name: 'PanelFirmas',
    data() {
        return {
            loading: true,
            panel: [],
            paginaActual: 1,
            objetosPorPagina: 50,
            filtros: {
                nombre: '',
                estado: '',
                fechaEnvio: '',
                destinatarios: ''
            }
        }
    },
    mounted() {
        this.obtenerPanel();
    },
    watch: {

    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'configEnvio', 'files', 'paginaActual', 'documentos', 'content', 'pub_titulo'
        ]),
        panelFiltrado() {
            return this.panel.filter((documento) => {
                return documento.nombreDocumento.toLowerCase().includes(this.filtros.nombre) &&
                    documento.estadoFirmado.toLowerCase().includes(this.filtros.estado) &&
                    documento.fecha.toLowerCase().includes(this.filtros.fechaEnvio) &&
                    documento.destinatario.toLowerCase().includes(this.filtros.destinatarios)
            }
            )
        },
        objetoCortado() {
            let entries = this.panelFiltrado;
            // Aplicar slice para obtener una parte del objeto
            const start = (this.paginaActual - 1) * this.objetosPorPagina;
            const end = start + this.objetosPorPagina;
            let trozo = entries.slice(start, end);

            return trozo;
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.paginaActual = val;
        },
        handleSizeChange(val) {
            this.objetosPorPagina = val;
        },
        async obtenerPanel() {
            let resp = await fetch(process.env.VUE_APP_APIDOMAIN + 'firmas/obtenerPanelFirmas', {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ token: this.datosemp.token })
            })
            if (resp.status == 200) {
                this.panel = await resp.json();
            } else {
                this.$router.push('/dashboard');
            }
            this.loading = false;
        },
        async infoDocumento(doc) {
            doc.loading = true;
            let resp = await fetch(process.env.VUE_APP_APIDOMAIN + 'firmas/getInfoDocs', {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ signedDocGui: doc.idDocumento })
            })
            if (resp.status) {
                resp = await resp.json();
                let texto = '';
                resp.Signers.forEach((signer) => {
                    texto += `<h3>${signer.SignerName}</h3>
                  <p><b>Estado: </b>${signer.SignatureStatus}<br>`;
                    if (signer.SignatureStatus == 'Rejected') {
                        texto += `<b>Motivo de rechazo: </b>${signer.RejectionReason}<br>`;
                    }
                    if (signer.OperationTime != null) {
                        texto += `<b>Fecha de actualización: </b>${signer.OperationTime}`;
                    }
                    texto += '</p>'; // Cerramos el párrafo
                });

                ElMessageBox.alert(texto, 'Información del documento: ' + doc.nombreDocumento, {
                    confirmButtonText: 'OK',
                    dangerouslyUseHTMLString: true,
                });
            }
            doc.loading = false;
        },
        async descargarDocumento(doc, tipo) {
            doc.loading = true;
            let resp = await fetch(process.env.VUE_APP_APIDOMAIN + 'firmas/getSignedDocument', {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ doc: doc.idDocumento })
            })
            if (resp.status == 200) {
                let base64 = await resp.json();
                base64 = base64[tipo];

                const nombreArchivo = tipo + '_' + doc.nombreDocumento;
                const tipoMime = 'application/pdf';

                // Convertir Base64 a un Blob
                let binaryString = window.atob(base64);
                let arrayBuffer = new ArrayBuffer(binaryString.length);
                let uint8Array = new Uint8Array(arrayBuffer);

                for (let i = 0; i < binaryString.length; i++) {
                    uint8Array[i] = binaryString.charCodeAt(i);
                }
                let blob = new Blob([uint8Array], { type: tipoMime });
                download(blob, nombreArchivo, tipoMime);
            }
            doc.loading = false;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
td,
th {
    border: 1px solid #ddd;
    padding: 8px;
}

tr:nth-child(even) {
    background-color: #f2f2f2;
}

tr:hover {
    background-color: #ddd;
}

th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #e6a23c;
    color: white;
}

tbody {
    display: block;
    height: 80vh;
    overflow: auto;
}

thead,
tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    /* even columns width , fix width of table too*/
}

thead {
    width: 100%
        /* scrollbar is average 1em/16px width, remove it from thead width */
}
</style>